import { axios } from "@/client/libs/axios";

export type PaymentPlan = {
  id: string;
  name: "one_time" | "subscription";
  price: number;
  durationDays: number | null;
  downloadsAllowed: number;
};

export type InitiatePaymentDto = {
  planId: string;
  email: string;
};

export type PaymentStatusResponse = {
  status: "PENDING" | "SUCCESSFUL" | "FAILED";
  amount: number;
  completedAt: string | null;
  type: "ONE_TIME_DOWNLOAD" | "MONTHLY_SUBSCRIPTION";
  orderTrackingId: string | null;
  subscription: {
    id: string;
    status: string;
    expiresAt: string | null;
    planName?: string;
  } | null;
};

export type PaymentHistoryItem = {
  id: string;
  amount: number;
  status: "PENDING" | "SUCCESSFUL" | "FAILED" | "CANCELLED";
  type: "ONE_TIME_DOWNLOAD" | "MONTHLY_SUBSCRIPTION";
  phoneNumber: string;
  mpesaReceiptNumber: string | null;
  createdAt: string;
  completedAt: string | null;
  subscription?: {
    id: string;
    status: string;
    expiresAt: string | null;
    plan: { name: string };
  };
};

export type PaymentHistoryResponse = {
  payments: PaymentHistoryItem[];
  total: number;
  hasMore: boolean;
  page: number;
};

export type InitiatePaymentResponse = {
  paymentId: string;
  redirectUrl: string;
  orderTrackingId: string;
};

export const paymentService = {
  /**
   * Get available payment plans
   */
  getPaymentPlans: async (): Promise<PaymentPlan[]> => {
    const response = await axios.get<PaymentPlan[]>("/payments/plans");
    return response.data;
  },

  /**
   * Initiate Pesapal payment
   */
  initiatePayment: async (data: InitiatePaymentDto): Promise<InitiatePaymentResponse> => {
    const response = await axios.post<InitiatePaymentResponse>("/payments/initiate", data);
    return response.data;
  },

  /**
   * Check payment status by paymentId
   */
  checkStatus: async (paymentId: string): Promise<PaymentStatusResponse> => {
    const response = await axios.get<PaymentStatusResponse>(`/payments/status/${paymentId}`);
    return response.data;
  },

  /**
   * Get user's payment history from the Payment table
   */
  getPaymentHistory: async (): Promise<PaymentHistoryResponse> => {
    const response = await axios.get<PaymentHistoryResponse>("/payments/my-payments");
    return response.data;
  },
};
